import { fetchBidderDataIfNeeded, getAuthToken, getBidderEmail } from './user';
import { getSignupFromFlattenTheCurvePage, getSignupReferralHouse } from './modal';
import { postUpdateProfile, UpdateProfileRequest } from '@/redux/api/bidder';
import CountriesWithISOCodes from '@liveauctioneers/caterwaul-components/lib/Intl/CountriesWithISOCodes';
import { createSelector } from 'reselect';
import { DISMISS_MODAL } from './actions';
import { getCompleteAccountAnalytics } from './analytics';
import { getDeployment } from './config';
import { getSeller } from './seller';
import { getSellerUrl } from '@/utils/urls';
import { GlobalState } from '../rootReducer';
import { push } from 'connected-react-router';

/* Action Types */
export const COMPLETE_ACCOUNT_FAIL = 'la/ui/completeAccount/FAIL';
export const COMPLETE_ACCOUNT_REQUEST = 'la/ui/completeAccount/REQUEST';
export const COMPLETE_ACCOUNT_SUCCESS = 'la/ui/completeAccount/SUCCESS';

// reducer
const DEFAULT_STATE = {
    error: false,
    submitted: false,
    success: false,
};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case DISMISS_MODAL:
            return {
                ...state,
                error: false,
                submitted: false,
                success: false,
            };
        case COMPLETE_ACCOUNT_FAIL:
            return {
                ...state,
                error: true,
                submitted: false,
                success: false,
            };
        case COMPLETE_ACCOUNT_REQUEST:
            return {
                ...state,
                submitted: true,
                success: false,
            };
        case COMPLETE_ACCOUNT_SUCCESS:
            return {
                ...state,
                submitted: false,
                success: true,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.completeAccount;

export const getUiCompleteAccount = createSelector(stateSelector, (state) => state);

/* ACTION CREATORS */
export const submitCompleteAccount = (updatedProfile: UpdateProfileRequest) => async (
    dispatch: Function,
    getState: Function
) => {
    try {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        // email is not set in the complete account form, it comes from the token at this point
        updatedProfile.email = getBidderEmail(state);

        // I think country at this point is a full name, we need to send the code and name to the api
        const countryValue = CountriesWithISOCodes.find((c) => c.name === updatedProfile.country);
        if (countryValue && countryValue.code3) {
            updatedProfile.countryCode = countryValue.code3;
        }

        dispatch({
            type: COMPLETE_ACCOUNT_REQUEST,
        });
        const response = await postUpdateProfile({
            authToken,
            deployment,
            profile: updatedProfile,
        });
        dispatch({
            meta: { ...getCompleteAccountAnalytics(), actionTime: Date.now() },
            payload: response,
            type: COMPLETE_ACCOUNT_SUCCESS,
        });

        dispatch(fetchBidderDataIfNeeded(null, true));

        const signupReferralHouse = getSignupReferralHouse(state);
        const signupFromFlattenTheCurvePage = getSignupFromFlattenTheCurvePage(state);
        const seller = getSeller(state, signupReferralHouse);

        if (signupFromFlattenTheCurvePage) {
            if (seller.name) {
                dispatch(push(getSellerUrl(seller.sellerId, seller.name)));
            } else {
                dispatch(push('/'));
            }
        }
    } catch (error) {
        dispatch({
            error: true,
            payload: error,
            type: COMPLETE_ACCOUNT_FAIL,
        });
    }
};
